<app-download-up></app-download-up>

<div class="container">
    <div class="row">
        <form id="findAddressForm" class='col-md-6 col-xs-12 firstCol' [formGroup]="postIndexForm" (ngSubmit)="submit()" autocomplete="off">
            <label class="col-md-12 col-xs-12 ">Пошук здійснюється за п'ятизначним індексом</label>
            <input type="text" class='col-md-12 col-xs-12' formControlName="postIndex" name='postIndex' id='postIndex' />
            <button type='submit' class='submitButton col-md-12 col-xs-12' [disabled]="!postIndexForm.valid">Знайти</button>
        </form>

        <response-address-loader id="responseAddress" [addressResponseReadySubject]="responseReadySubject" [clear]="requestForDataPosted" class="loader no-side-padding col-md-6 col-xs-12 secondCol " ></response-address-loader>
    </div>
</div>

<div class="link-list">
    <a href="/find-post-index" class="link-grey">Знайти індекс за адресою</a>
    <a href="https://offices.ukrposhta.ua/" class="link-grey">Знайти відділення</a>
    <a href="/postcodes-and-offices" class="link-grey">Довідка</a>
</div>
